import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-dollar-svg-icon',
    templateUrl: 'duotone-dollar-svg-icon.component.html',
    standalone: false
})

export class DuotoneDollarSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
